import React from 'react';
import { Menu, Bot, Filter, AlertCircle } from 'lucide-react';

const ChatHeader = ({
  onToggleLeftSidebar,
  onToggleRightSidebar,
  currentSessionTitle,
  sessionId,
  connectionStatusText,
  apiError,
  activeFiltersCount
}) => {
  return (
    <div className="border-b border-gray-200 p-4 bg-white">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <button
            onClick={onToggleLeftSidebar}
            className="text-gray-600 hover:text-black p-2 hover:bg-gray-100 transition-colors"
            title="Toggle chat history"
          >
            <Menu size={20} />
          </button>
          <div className="w-10 h-10 bg-electric-blue flex items-center justify-center">
            <Bot className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-lg text-black">
              {currentSessionTitle}
            </h1>
            {/* <p className="text-sm text-gray-600">
              AI-powered insights • Session: {sessionId?.slice(-8)} •{" "}
              {connectionStatusText}
            </p> */}
          </div>
        </div>

        <div className="flex items-center space-x-2">
          {apiError && (
            <div className="flex items-center text-red-600 text-sm">
              <AlertCircle size={16} className="mr-1" />
              <span className="hidden sm:inline">API Error</span>
            </div>
          )}
          <button
            onClick={onToggleRightSidebar}
            className="p-2 text-gray-600 hover:text-black hover:bg-gray-100 transition-colors relative"
            title="Toggle filters"
          >
            <Filter size={20} />
            {activeFiltersCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center">
                {activeFiltersCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;